(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/swish-cellphone/assets/prescript.js') >= 0) return;  svs.modules.push('/components/accountservices-react/swish-cellphone/assets/prescript.js');
'use strict';

svs.accountservicesReact = svs.accountservicesReact || {};
svs.accountservicesReact.swishCellphone = svs.accountservicesReact.swishCellphone || {};

 })(window);